import {
	MODULE_NAME,
	BETA_FEATURE,
	BETA_FEATURES,
	BETA_FEATURES_ALL,
	RELOAD_BETA_FEATURES,
	SAVE_BETA_FEATURE,
	GO_LIVE_BETA_FEATURE,
	SET_BETA_FEATURE,
	SET_BETA_FEATURES,
	SET_BETA_FEATURES_ALL,
	SHOW_BETA_FEATURE_MODAL,
	TOAST_MESSAGES_PUSH,
	HISTORY_LOGS,
	SET_HISTORY_LOGS
} from './beta-features-mutation-types';
import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

const baseApi = `/${MODULE_NAME}`;

let messageObj = {
	statusCode: 400,
	message: 'An occurred an error. Try again'
};

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[BETA_FEATURE]: null,
		[BETA_FEATURES]: {},
		[BETA_FEATURES_ALL]: {},
		[RELOAD_BETA_FEATURES]: false,
		[SHOW_BETA_FEATURE_MODAL]: false,
		[HISTORY_LOGS]: {}
	},
	mutations: {
		//beta-features
		[RELOAD_BETA_FEATURES](state, value) {
			state[RELOAD_BETA_FEATURES] = value;
		},
		[SET_BETA_FEATURES](state, obj) {
			state[BETA_FEATURES] = obj;
		},
		[SET_BETA_FEATURES_ALL](state, obj) {
			state[BETA_FEATURES_ALL] = obj;
		},
		[SET_BETA_FEATURE](state, obj) {
			state[BETA_FEATURE] = obj;
			state[SHOW_BETA_FEATURE_MODAL] = obj !== null;
		},
		[SHOW_BETA_FEATURE_MODAL](state, value) {
			state[SHOW_BETA_FEATURE_MODAL] = value;
		},

		//transactions
		[SET_HISTORY_LOGS](state, obj) {
			state[HISTORY_LOGS] = obj;
		}
	},
	actions: {
		[SHOW_BETA_FEATURE_MODAL]({ commit }, value) {
			commit(SHOW_BETA_FEATURE_MODAL, value);
		},
		async [SAVE_BETA_FEATURE]({ dispatch, commit }, obj) {
			let action = 'added';
			const parseResponse = () => {
				messageObj = {
					statusCode: 200,
					message: `Beta Feature successfully ${action}.`
				};
				dispatch(SET_BETA_FEATURE, null);
				commit(RELOAD_BETA_FEATURES, true);
			};
			let result;
			if (obj.id) {
				action = 'edited';
				result = await api
					.put(`${baseApi}/${obj.id}`, obj)
					.then(res => {
						parseResponse(res);
					})
					.catch()
					.finally(() => {
						dispatch(TOAST_MESSAGES_PUSH, messageObj, {
							root: true
						});
					});
			}
			return result;
		},
		async [GO_LIVE_BETA_FEATURE]({ dispatch, commit }, id) {
			let action = 'Go live';
			const parseResponse = () => {
				messageObj = {
					statusCode: 200,
					message: `Beta Feature ${action} performed successfully.`
				};
				dispatch(SET_BETA_FEATURE, null);
				commit(RELOAD_BETA_FEATURES, true);
			};
			let result;
			if (id) {
				result = await api
					.post(`${baseApi}/golive/${id}`)
					.then(res => {
						parseResponse(res);
					})
					.catch()
					.finally(() => {
						dispatch(TOAST_MESSAGES_PUSH, messageObj, {
							root: true
						});
					});
			}

			return result;
		},
		async [SET_BETA_FEATURES]({ commit }, params) {
			commit(SET_BETA_FEATURES, {});

			const results = await api.get(buildRoute(baseApi, params));

			commit(SET_BETA_FEATURES, results);
			commit(RELOAD_BETA_FEATURES, false);
		},

		async [SET_BETA_FEATURES_ALL]({ commit }, params) {
			commit(SET_BETA_FEATURES_ALL, {});

			const results = await api.get(buildRoute(baseApi, params));

			commit(SET_BETA_FEATURES_ALL, results);
			//commit(RELOAD_BETA_FEATURES, false);
		},

		async [SET_BETA_FEATURE]({ dispatch, commit }, id) {
			if (!id) {
				commit(SET_BETA_FEATURES, {});
				return;
			}
			let hasResultValue = false;
			await api
				.get(`${baseApi}/${id}`)
				.then(res => {
					commit(SET_BETA_FEATURE, res);
					hasResultValue = true;
				})
				.catch(error => {
					let obj = JSON.parse(JSON.stringify(messageObj));
					if (error) {
						obj.message = error;
					} else {
						obj.message = 'Beta Feature not found';
					}
					dispatch(TOAST_MESSAGES_PUSH, obj, {
						root: true
					});
				});
			return hasResultValue;
		},
		//transactions
		async [SET_HISTORY_LOGS]({ commit }, params) {
			commit(SET_HISTORY_LOGS, {});

			const results = await api.get(
				buildRoute(`${baseApi}/versionhistory`, params)
			);

			commit(SET_HISTORY_LOGS, results);
		}
	},
	getters: {
		[BETA_FEATURE]: state => state[BETA_FEATURE],
		[BETA_FEATURES]: state => state[BETA_FEATURES],
		[RELOAD_BETA_FEATURES]: state => state[RELOAD_BETA_FEATURES],
		[SHOW_BETA_FEATURE_MODAL]: state => state[SHOW_BETA_FEATURE_MODAL],
		[HISTORY_LOGS]: state => state[HISTORY_LOGS]
	}
};
